import React from "react";
import { observer } from "mobx-react";
import { action, makeObservable, observable } from 'mobx';
import { Select, Space } from 'antd';

@observer
export class VariationsLinks extends React.Component {
    onChange = (oldId, newId) => {
        const oldIndex = this.props.variationsIds.indexOf(oldId);
        if (oldIndex > -1) {
            this.props.variationsIds[oldIndex] = newId;
        } else {
            this.props.variationsIds.push(newId);
        }
    }

    render() {
        return (
            <Space wrap size={4}>
                {this.props.variationsTypes.map(variationType => (
                    <VariationsLink
                        key={variationType.id}
                        variationType={variationType}
                        variationsIds={this.props.variationsIds}
                        onChange={this.onChange}
                    />
                ))}
            </Space>
        );
    }
}

@observer
class VariationsLink extends React.Component {
    @observable selectedVariationId = null;

    @action.bound setSelectedVariationId = (id) => this.selectedVariationId = id;

    constructor(props) {
        super(props);
        makeObservable(this);
    }

    componentWillReceiveProps(nextProps) {
        this.init(nextProps);
    }

    componentDidMount() {
        this.init(this.props);
    }

    init = (props) => {
        const variation = props.variationType.variations.find(({ id }) => props.variationsIds.includes(id));
        if (typeof variation !== 'undefined') {
            this.setSelectedVariationId(variation.id);
        }
    }

    onChange = (newValue) => {
        this.props.onChange(this.selectedVariationId, newValue);
        this.setSelectedVariationId(newValue);
    }

    render() {
        if (this.props.variationType.variations.length === 0) {
            return null;
        }

        const options = this.props.variationType.variations.map(({ id, title }) => ({ value: id, label: title }));

        return (
            <Select
                size="small"
                value={this.selectedVariationId || undefined}
                onChange={this.onChange}
                options={options}
                placeholder="Choose…"
                status={!this.selectedVariationId ? 'error' : ''}
                style={{ minWidth: 100 }}
            />
        );
    }
}
